/* eslint-disable sonarjs/no-duplicate-string */
import 'system/blocks/b-masked-input/b-masked-input';

define((require) => {
    'use strict';

    const FormLayer = require('system/blocks/form-layer/form-layer');

    return FormLayer.extend('billing-registration__stage-legal', {
        inner: true,
        renderMode: 'replace',
        service: false,

        title: 'Дорегистрация',

        onAccept() {
            const form = this._form;
            let data;

            if (form.validate()) {
                data = this.getFormData();

                this.emit('continue', data);
            }
        },

        onRollback() {
            const data = this.getFormData();

            this.emit('back', data);
        },

        onClose() {
            this.emit('cancel');
        },

        width: 420,

        mods: [
            'centered-header',
            'billing-registration',
            'billing-registration__stage-legal',
        ],

        buttons: [
            {
                block: 'dot-pager',
                dotCount: 2,
                activeDot: 1,
                mods: ['center'],
            },
            {
                name: 'accept',
                text: 'Подтвердить',
                mods: ['main', 'right', 'single'],
            },
        ],

        fields(data) {
            const defs = this.defs;

            return [
                {
                    columns: [
                        {
                            block: 'b-input',
                            label: 'ИНН',
                            mods: ['responsive', 'icon-search'],
                            errors: [
                                {
                                    type: 'invalid',
                                    text: 'Неверный ИНН',
                                },
                                {
                                    type: 'pattern',
                                    text:
                                        'ИНН должен состоять из 10 или 12 цифр',
                                },
                                {
                                    type: 'required',
                                    text: 'Заполните ИНН',
                                },
                            ],
                            props: {
                                placeholder:
                                    'Введите свой ИНН (10 или 12 цифр)',
                                type: 'text',
                                name: defs.INN,
                                value: data[defs.INN],
                                required: true,
                                'data-pattern': '^(\\d+)$',
                                maxlength: 12,
                                autofocus: 'autofocus',
                                tabindex: 1,
                            },
                        },
                    ],
                },
                {
                    columns: [
                        {
                            block: 'b-input',
                            label: 'ОГРН',
                            mods: ['responsive'],
                            errors: [
                                {
                                    type: 'invalid',
                                    text: 'Неверно заполненное поле',
                                },
                                {
                                    type: 'pattern',
                                    text: 'ОГРН должен состоять из цифр',
                                },
                                {
                                    type: 'required',
                                    text: 'Заполните ОГРН',
                                },
                            ],
                            props: {
                                placeholder: '',
                                type: 'text',
                                name: defs.OGRN,
                                value: data[defs.OGRN],
                                required: true,
                                'data-pattern': '^(\\d+)$',
                                maxlength: 50,
                                tabindex: 2,
                            },
                        },
                    ],
                },
                {
                    columns: [
                        {
                            block: 'b-input',
                            label: 'КПП',
                            mods: ['responsive'],
                            errors: [
                                {
                                    type: 'invalid',
                                    text: 'Неверно заполненное поле',
                                },
                                {
                                    type: 'required',
                                    text: 'Заполните КПП',
                                },
                            ],
                            props: {
                                placeholder: '',
                                type: 'text',
                                name: defs.KPP,
                                value: data[defs.KPP],
                                tabindex: 3,
                                required: true,
                            },
                        },
                    ],
                },
                {
                    columns: [
                        {
                            block: 'b-input',
                            label: 'Название организации',
                            mods: ['responsive'],
                            errors: [
                                {
                                    type: 'invalid',
                                    text: 'Неверно заполненное поле',
                                },
                                {
                                    type: 'required',
                                    text: 'Заполните название организации',
                                },
                            ],
                            props: {
                                placeholder: '',
                                type: 'text',
                                name: defs.LEGAL_NAME,
                                value: data[defs.LEGAL_NAME],
                                tabindex: 4,
                                required: true,
                            },
                        },
                    ],
                },
                {
                    columns: [
                        {
                            block: 'b-masked-input',
                            label: 'Телефон',
                            mods: ['responsive'],
                            errors: [
                                {
                                    type: 'invalid',
                                    text: 'Неверный телефон',
                                },
                                {
                                    type: 'pattern',
                                    text: 'Неверный формат: +7 (123) 123-45-67',
                                },
                                {
                                    type: 'required',
                                    text: 'Заполните телефон',
                                },
                            ],
                            props: {
                                placeholder: '+7 (123) 123-45-67',
                                type: 'text',
                                name: defs.PHONE,
                                value: data[defs.PHONE],
                                'data-pattern': '^\\d{3,22}$',
                                tabindex: 5,
                                required: true,
                                maskPattern: 'phone',
                            },
                        },
                    ],
                },
            ];
        },

        onRender() {
            FormLayer.fn.onRender.call(this);

            const innInput = this._form.getField(this.defs.INN);
            innInput.input.el.setSelectionRange(
                this.innInputState.start,
                this.innInputState.end,
            );
        },
    });
});
